import {mediator} from '@communication'


export default function useBroadcast () {
  const broadcast = mediator.broadcast
  return broadcast
}
